module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: ("Form__label Form__label--" + _vm.cleanLabel),
    attrs: {
      "for": _vm.cleanLabel
    }
  }, [_c('span', {
    staticClass: "Form__label-text"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.required) ? _c('abbr', {
    staticClass: "Form__label-required",
    attrs: {
      "title": "required"
    }
  }, [_vm._v("*")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11afda8e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Form/FormLabel.vue
// module id = 236
// module chunks = 1